import { Text, Icon, Chip } from "@virkesborsen/ui-component-library";
import { useDrone } from "../../../context/DroneContext";

const getPackageText = (p) => {
  if (p.id === 0) {
    return {
      id: 0,
      title: "Bas",
      subtitle: "Skadeanalys: Barkborre",
      description:
        "Utöver högupplösta bilder av skogen får du en analys av borkborreskador",
      price: p.price_ha,
      internalName: p.internal_name,
      minimumOrderAmount: p.minimum_order_amount,
    };
  }

  if (p.id === 1) {
    return {
      id: 1,
      title: "Plus",
      subtitle: "Skadeanalys: Barkborre och toppbrottsanalys",
      description:
        "Identifiera både barkborreangrepp och toppbrott för att agera i tid, undvika spridning och rädda virkesvärden",
      price: p.price_ha,
      internalName: p.internal_name,
      minimumOrderAmount: p.minimum_order_amount,
    };
  }

  return;
};

const Card = ({
  id,
  title,
  subtitle,
  description,
  price,
  isSelected,
  onClick,
}) => {
  const textPrimaryColor = isSelected ? "text-white-50" : "text-charcoal-500";
  const textSecondaryColorPremium = isSelected
    ? "text-purple-plum-200"
    : "text-purple-plum-500";
  const textSecondaryColorBase = isSelected
    ? "text-cloud-500"
    : "text-cloud-900";
  const chipClasses = isSelected
    ? "bg-purple-plum-500 fill-white-50 text-white-50"
    : "bg-purple-plum-500/8 fill-purple-plum-500 text-purple-plum-500";
  const bgColor = isSelected ? "bg-charcoal-500" : "bg-white-50";

  const IconColor = isSelected
    ? "fill-spring-yellow-500 text-spring-yellow-500"
    : "fill-purple-plum-500 text-purple-plum-500";

  const hectarTextColor = isSelected ? "text-white-600" : "text-pebble-500";

  return (
    <div
      className={`flex flex-row gap-2 w-full border border-transparent justify-between p-4 rounded-xl cursor-pointer hover:border-pebble-500 ${bgColor}`}
      onClick={onClick}
    >
      <div className="flex flex-col">
        <div className="flex flex-row gap-1 items-baseline pb-1">
          <Text variant="labelLargeMedium" className={textPrimaryColor}>
            Skadeanalys
          </Text>
          <Text
            variant="labelMediumMedium"
            className={
              id === 1 ? textSecondaryColorPremium : textSecondaryColorBase
            }
          >
            {title}
          </Text>
        </div>
        <Text
          variant="labelMediumRegular"
          className={`pb-3 ${textPrimaryColor}`}
        >
          {subtitle}
        </Text>

        <Text variant="bodySmallRegular" className={`pb-4 ${textPrimaryColor}`}>
          {description}
        </Text>
        <div
          className={`flex flex-row gap-2 items-center ${
            isSelected || id === 1 ? "opacity-100" : "opacity-0"
          }`}
        >
          <Icon
            tw
            name={isSelected ? "CheckFilled" : "SparkleSimple"}
            size="large"
            className={
              isSelected ? "fill-spring-yellow-500" : "fill-purple-plum-500"
            }
          />
          <Text variant="labelSmallMedium" className={IconColor}>
            {isSelected ? "Tillagd" : id === 1 ? "Rekommenderad" : ""}
          </Text>
        </div>
      </div>

      <div className="flex flex-col h-full justify-between items-end">
        <Chip
          label="Tillägg"
          size="medium"
          icon="PlusSimple"
          className={chipClasses}
        />

        <div className="flex flex-col items-end gap-1">
          <div className="flex flex-row gap-1 items-baseline">
            <Text
              variant="displayAndHeadline2XtraSmallMedium"
              className={textPrimaryColor}
            >
              {price}
            </Text>
            <Text variant="labelLargeRegular" className={textPrimaryColor}>
              SEK
            </Text>
          </div>
          <Text variant="captionRegular" className={hectarTextColor}>
            per hektar
          </Text>
        </div>
      </div>
    </div>
  );
};

export default function PackageSelect() {
  const { dronePrices, selectedPackage, setSelectedPackage } = useDrone();

  if (!dronePrices?.packages) {
    return <div className="flex p-4">Laddar...</div>;
  }

  const packages = dronePrices.packages.map((p) => getPackageText(p));

  const handlePackageSelect = (p) => {
    if (selectedPackage?.id === p.id) {
      setSelectedPackage(null);
      return;
    }

    setSelectedPackage(p);
  };

  return (
    <div className="flex flex-col w-full">
      <div className="w-full flex flex-col gap-4">
        <Text variant="labelLargeMedium" className="pl-4">
          Välj extra tjänster
        </Text>
        <div className="flex flex-col gap-4">
          {packages.map((p) => (
            <Card
              key={p.title}
              {...p}
              isSelected={selectedPackage?.id === p.id}
              onClick={() => handlePackageSelect(p)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
